/**
 * Carrinho de compra — MESMA assinatura pública de sempre
 * (`{items, summary, addItem, updateItemQuantity, removeItem, clear, payloadItems}`),
 * mas agora lê/escreve o `CartContext` (single source of truth montado no
 * App.js). Sellout, Purchasing e /operacoes compartilham o MESMO carrinho com
 * re-render cruzado; persistência em localStorage (mesma key/shape) continua
 * no provider.
 */
import { useCart } from '../contexts/CartContext';

export function usePurchaseCart() {
    return useCart();
}
